import {FormationDto, IFormationWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class EnregistrementFormationResolver implements Resolve<FormationDto> {

  constructor(private formationWebService: IFormationWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let id = route.params['id'];
    return this.formationWebService.findFormation(id);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/administration/formation/enregistrement/enregistrement.formation.resolver.ts